import { useContext } from 'react';
import { dumbPluralize } from '@/utils/helpers';
import { RadioField, Radio } from '@zopauk/web-ui';
import { formatCurrency } from '@zopauk/libs-formats';
import { CalculatorContext } from '@/components/Calculator/Context';

/**
 * TODO(WEBUI):
 *
 * We need to allow the passing of react attributes to the
 * Radio and CheckBox Components
 */

export const Terms = ({ id }: Record<'id', string>) => {
  const context = useContext(CalculatorContext);

  if (!context.pricing) {
    return null;
  }

  return (
    <>
      <div className="flex mb-5">
        <span className="font-semibold flex-1 indent-6">Term</span>
        <span className="font-semibold flex-1 text-center">
          <abbr style={{ textDecoration: 'none' }} title="Annual percentage rate">
            APR
          </abbr>
        </span>
        <span className="font-semibold flex-1 text-right">Monthly cost</span>
      </div>
      <div className="mb-6">
        <RadioField aria-label="Select a loan term" label="Select a loan term" hideLabel>
          {context.termInformation.map((term, index) => {
            const currency = formatCurrency(term.value);
            const percentage = `${term.apr}%`;
            const years = `${term.years} ${dumbPluralize(term.years, 'year')}`;

            return (
              <Radio
                label={
                  <span className="flex w-full">
                    <span data-automation={`ZA.term-years-${index + 1}`} className="flex-[2] text-left">
                      {years}
                    </span>
                    <span
                      className="flex-1 -ml-5 border-l border-l-secondary text-center"
                      data-automation={`ZA.apr-percent-${index + 1}`}
                    >
                      {percentage}
                    </span>
                    <span
                      className="flex-[2] border-l border-l-secondary text-right"
                      data-automation={`ZA.monthlycost-value-${index + 1}`}
                    >
                      {currency}
                    </span>
                    <span className="sr-only">
                      Select this loan for {years} at a monthly cost of {currency} with an APR of {percentage}
                    </span>
                  </span>
                }
                onClick={(event) => {
                  const value = event.currentTarget.value;
                  const extractedTerm = value.substring(value.lastIndexOf('-') + 1);
                  context.setSelectedTerm(Number.parseInt(extractedTerm));
                }}
                checked={term.term === context.selectedTerm}
                value={`${id}-${term.term}`}
                name={`${id}-terms`}
                key={term.term}
              />
            );
          })}
        </RadioField>
      </div>
    </>
  );
};
